import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-209">
      <div className="max-w-2xl mx-auto text-center" data-id="element-210">
        {/* Shield icon */}
        <div className="text-8xl mb-6" data-id="element-211">🛡️</div>

        <h2 className="text-3xl sm:text-4xl font-black text-[#FFD700] mb-4" data-id="element-212">
          GARANTÍA PROFEPACK™ — 7 DÍAS
        </h2>

        <div className="bg-[#0d0a00] border-2 border-[#FFD700] rounded-2xl p-8 mb-6" data-id="element-213">
          <p className="text-white text-lg mb-4 leading-relaxed" data-id="element-214">
            Abrís los 6 tomos. Revisás los 6 bonos. Los usás en la clase si
            querés.
          </p>
          <p className="text-white text-lg mb-6 leading-relaxed" data-id="element-215">
            Si en 7 días no es lo que esperabas:
          </p>
          <p className="text-[#FFD700] text-3xl font-black mb-4" data-id="element-216">
            Te devolvemos el 100%.
          </p>
          <p className="text-white text-xl font-bold" data-id="element-217">
            Sin preguntas. Sin formularios. Sin drama.
          </p>
        </div>

        <p className="text-gray-400 text-sm leading-relaxed" data-id="element-218">
          La confianza que tenemos en el MegaPack Batería Lista nos permite
          hacer esa promesa sin dudar.
          <br data-id="element-219" />
          Más de 500 profes de batería ya lo saben. La tasa de devoluciones es
          menor al 1%.
        </p>
      </div>
    </section>;
}